/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import React, {useEffect, useState} from "react";
import {withRouter} from 'react-router-dom'
import {Button, Card, Form, Input} from "antd";
import {isLoggedIn, login} from "../core/auth/authentication";


function LoginView(props: any) {
    const [isFetching, setIsFetching] = useState(false);
    useEffect(() => isLoggedIn(), []);

    return (
        <div className='bg-container'>
            <Card
                className="login-container"
            >
                <span style={{textAlign: 'center'}}>
                    <h1
                        style={{marginTop:0}}
                    >[ MPExpert ]</h1>
                </span>

                <form key='auth' id='login' name='login' onSubmit={(e: any) => {
                    e.preventDefault();
                    const data = new FormData(e.target);
                    setIsFetching(true);
                    login(data.get('user') as string, data.get('password') as string).always(
                        () => setIsFetching(false)
                    );
                }}>
                    <Form.Item>
                        <Input key='user'
                               id='user'
                               name='user'
                               placeholder='Benutzer'
                               required
                        />
                    </Form.Item>
                    <Form.Item>
                        <Input.Password id='password' name='password' placeholder='Passwort' required/>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={isFetching}
                            block
                        >
                            {isFetching ? "" : "Log In"}
                        </Button>
                    </Form.Item>
                </form>
            </Card>
        </div>
    )
        ;
}


export default withRouter(LoginView)